<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
jQuery(document).ready(function($){
  $(document).on('click', '.productView-thumbnail', function(){
    let index = $(this).data('slick-index');
    $(this).closest('.productView-images').find('.slick-dots>li').eq(index).click();
  });
});